const errors: { [key: string]: string } = {
  "auth.account-disabled": "Ce compte est désactivé.",
};

export default errors;
